// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"8a16cf34","506":"48c211e2"}[chunkId] + ".chunk.css";
};